import { linkedIssuesInitialDisplayCount } from '@jira/issue__constants/src/linkedIssuesInitialDisplayCount.tsx';
import { fg } from '@atlassian/jira-feature-gating';

const linkedIssuesInitialLoadRowsCount = {
	get(): number | null {
		return fg('jira_linked_issues_pagination') ? linkedIssuesInitialDisplayCount : null;
	},
};

export default linkedIssuesInitialLoadRowsCount;
